<app-template>
    <app-breadcrumb>
        <li class="breadcrumb-item"><a routerLink="/">Home</a></li>
        <li class="breadcrumb-item">Setup</li>
        <li class="breadcrumb-item active">Permissions</li>
    </app-breadcrumb>
</app-template>